// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2N9TE","selects":"Documents_selects__2Ai1o"};